import React, { Component } from "react";
import Helmet from "react-helmet";
import ContactFind from "../components/Contact/ContactFind";
import config from "../../data/SiteConfig";
import Header from "../components/Header/Header";
import Clear from "../components/Structure/Clear";
import SocialLinks from "../components/SocialLinks/SocialLinks";
import SEO from "../components/SEO/SEO";
import HeaderPage from "../components/Header/HeaderPage";
import Footer from "../components/Footer/Footer";
import picture from "./img/contact.jpg";
import Menu from "../components/Menu/Menu";

class ContactPage extends Component {
  render() {
    const { slug } = this.props.pathContext;

    let title = "Contacter Integral Service";
    let description = "On vous répond rapidement !";
    let goto = "";

    const postNode = {
        "frontmatter": {
            "title": title,
            "description": "Contacter le studio Web spécialisé dans la création d'application web INTEGRAL SERVICE.",
            "cover": picture
        }
    };

    return (
        <div className="contact">
            <Helmet title={title} />
            <SEO postPath={slug} postNode={postNode} postSEO />
            <Menu />
            <Header />
            <HeaderPage title={title} description={description} picture={picture} />
            <ContactFind />
            <Clear />
            <Footer />
        </div>
    );
  }
}

export default ContactPage;



// WEBPACK FOOTER //
// ./src/pages/contact.jsx